import client from "./client.js";

export async function fetchGroups() {
  const res = await client.get("/groups");
  return res.data.data;
}

export async function fetchGroup(id) {
  const res = await client.get(`/groups/${id}`);
  return res.data.data;
}

export async function createGroup(payload) {
  const res = await client.post("/groups", payload);
  return res.data.data;
}

export async function updateGroup(id, payload) {
  const res = await client.patch(`/groups/${id}`, payload);
  return res.data.data;
}

export async function deleteGroup(id, { deleteMonitors = false } = {}) {
  const res = await client.delete(`/groups/${id}`, {
    params: deleteMonitors ? { delete_monitors: "true" } : undefined,
  });
  return res.data.data;
}

export async function updateGroupMembers(id, monitorIds) {
  const res = await client.put(`/groups/${id}/members`, {
    monitor_ids: monitorIds,
  });
  return res.data.data;
}

export async function quickSetup(payload) {
  const res = await client.post("/groups/quick-setup", payload);
  return res.data.data;
}
